import React, { useEffect, useState } from "react";

const withScreenType = WrappedComponent => {
	const WithHOC = props => {
		const [screenType, setScreenType] = useState("");
		useEffect(() => {
			function screenTest(e) {
				if (e.matches) {
					setScreenType("mobile");
				} else {
					setScreenType("tablet/desktop");
				}
			}
			const mediaQueryList = window.matchMedia("(max-width: 1124px)");
			screenTest(mediaQueryList);
			mediaQueryList.addListener(screenTest);
			return () => {
				mediaQueryList.removeListener(screenTest);
			};
		}, []);

		return (
			<ScreenContext.Consumer>
				{() => <WrappedComponent {...props} screenType={screenType} />}
			</ScreenContext.Consumer>
		);
	};
	WithHOC.WrappedComponent = WrappedComponent;
	return WithHOC;
};

const ScreenContext = React.createContext(null);

export default withScreenType;
